/*
 * Marketing API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.26
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';
import {Property} from './Property';
import {TemplatesContent} from './TemplatesContent';

/**
 * The Template model module.
 * @module model/Template
 * @version 1.0.0
 */
export class Template {
  /**
   * Constructs a new <code>Template</code>.
   * @alias module:model/Template
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>Template</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/Template} obj Optional instance to populate.
   * @return {module:model/Template} The populated <code>Template</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new Template();
      if (data.hasOwnProperty('_id'))
        obj._id = ApiClient.convertToType(data['_id'], 'String');
      if (data.hasOwnProperty('property'))
        obj.property = Property.constructFromObject(data['property']);
      if (data.hasOwnProperty('title'))
        obj.title = ApiClient.convertToType(data['title'], 'String');
      if (data.hasOwnProperty('description'))
        obj.description = ApiClient.convertToType(data['description'], 'String');
      if (data.hasOwnProperty('content'))
        obj.content = TemplatesContent.constructFromObject(data['content']);
      if (data.hasOwnProperty('created'))
        obj.created = ApiClient.convertToType(data['created'], 'String');
      if (data.hasOwnProperty('updated'))
        obj.updated = ApiClient.convertToType(data['updated'], 'String');
    }
    return obj;
  }
}

/**
 * @member {String} _id
 */
Template.prototype._id = undefined;

/**
 * @member {module:model/Property} property
 */
Template.prototype.property = undefined;

/**
 * @member {String} title
 */
Template.prototype.title = undefined;

/**
 * @member {String} description
 */
Template.prototype.description = undefined;

/**
 * @member {module:model/TemplatesContent} content
 */
Template.prototype.content = undefined;

/**
 * @member {String} created
 */
Template.prototype.created = undefined;

/**
 * @member {String} updated
 */
Template.prototype.updated = undefined;

